import { render } from "./ContentPages.vue?vue&type=template&id=34d34e20"
import script from "./ContentPages.vue?vue&type=script&lang=js"
export * from "./ContentPages.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__